// Users whose role only carries quote permissions live in the mobile DSE app.
export function isQuoteOnlyUser(user) {
  if (!user || user.role === "admin") return false;
  const perms = user.permissions || [];
  return perms.length > 0 && perms.every((p) => p.startsWith("quotes."));
}
